import { ListDiagnosisReport } from '~/domain/usecases/diagnosisReport/redux/ListDiagnosisReport';
import {
  iActionList,
  iActionListFailed,
  iActionListSuccess,
  DiagnosisReportTypes,
} from '~/domain/interfaces/redux/diagnosisReport/list';

export const listRequest = (
  payload: ListDiagnosisReport.Params,
): iActionList => ({
  type: DiagnosisReportTypes.LIST,
  payload,
});

export const listSuccess = (
  params: ListDiagnosisReport.Model,
): iActionListSuccess => ({
  type: DiagnosisReportTypes.LIST_SUCCESS,
  payload: params,
});

export const listFailed = (): iActionListFailed => ({
  type: DiagnosisReportTypes.LIST_FAILED,
});
